export const styles = {
  cameraButton: {
    height: 46,
    width: 46,
  },
  cameraIcon: {
    height: 40,
    width: 40,
  },
  progress: {
    color: "events.bluePrimary",
  },
};
